<div class="w-full p-20 bg-pastel-blue border-box h-full scroll-y">
  <!-- <div class="flex gap-20 mb-20">
    <div>
      <img src="assets/cerfa-icon.svg" alt="list">
    </div>
    <div>
      <h3 class="light-blue no-margin text-lg">Scellement de l'urne</h3>
      <p class="dark-gray no-margin text-sm">
        Les membres du bureau de vote doivent générer et valider leur clé de sécurité pour sceller le système de vote.
      </p>
    </div>
  </div> -->

  <div class="flex flex-column gap-20">
    <!-- <div class="p-20 bg-white border-box"
      style="display: grid; grid-template-columns: calc(24% - 6.67px) calc(38% - 6.67px) calc(38% - 6.67px); gap: 10px">
      <div>
        <p class="dark-blue no-margin bold">
          Progression de la validation
        </p>
        <p class="dark-gray text-sm mb-10">
          TMP
        </p>
      </div>

      <div>
        <p class="dark-blue no-margin bold">
          Garantissez l'intégrité du scrutin
        </p>
        <p class="dark-gray text-sm mb-10">
          Le scellement du système est l'étape finale pour assurer l'invulnérabilité des votes. En générant votre clé
          dès maintenant, vous permettez l'ouverture officielle de l'urne électronique dans le respect du protocole de
          sécurité..
        </p>
      </div>

      <div>
        <p class="dark-blue no-margin bold">
          Étape obligatoire avant l'ouverture du vote
        </p>
        <p class="dark-gray text-sm mb-10">
          Conformément aux exigences de sécurité, chaque membre du bureau doit activer sa clé de chiffrement. Cliquez
          pour générer votre clé et finaliser immédiatement le scellement du dispositif.
        </p>
      </div>

    </div> -->

    <div *ngIf="currentStep == 1">
      <app-assessors-details [assessors]="assessors" [isValidated]="unsealStepReady"></app-assessors-details>
      <app-assessors-invite (inviteAssessorsEvent)="inviteAssessors()" [isValidated]="testStepStatus != 'Planned'"></app-assessors-invite>
      <app-assessors-track *ngIf="testStepStatus != 'Planned'" (relaunchAssessorEvent)="relaunchAssessor($event)" (updateAssessorEvent)="updateAssessorEvent.emit($event)"
      [assessors]="assessors" [remainingAssessors]="remainingAssessors" [inactiveAssessors]="inactiveAssessors" 
      [isValidated]="remainingAssessors == 0 || testStepStatus == 'AssessorTesting' || testStepStatus == 'AssessorTestCompleted'"></app-assessors-track>
      <!-- <p>{{isTestVoteOpen}}</p> -->
      <app-assessors-start *ngIf="testStepStatus != 'Planned'" (inviteAssessorsEvent)="inviteAssessorsVote()" 
      [isValidated]="remainingAssessors == 0 || testStepStatus == 'AssessorTesting' || testStepStatus == 'AssessorTestCompleted'"
      [isTestVoteOpen]="isTestVoteOpen"></app-assessors-start>
      <app-assessors-votes *ngIf="isTestVoteOpen" [assessorQuorum]="assessorQuorum" [isValidated]="unsealStepReady"></app-assessors-votes>
      <app-assessors-stop *ngIf="isTestVoteOpen" (inviteAssessorsEvent)="closeAssessorsVote()" [isValidated]="unsealStepReady"></app-assessors-stop>
    </div>

    <div *ngIf="currentStep == 2">
      <app-assessors-unseal (relaunchAssessorEvent)="relaunchAssessor($event)" (updateAssessorEvent)="updateAssessorEvent.emit($event)" 
      [assessors]="assessors" [remainingAssessors]="remainingAssessors"
      [unsealedAssessors]="unsealedAssessors" [isValidated]="isBallotUnsealed"></app-assessors-unseal>
      <app-assessors-result (displayResultEvent)="displayResultEvent.emit()" [isValidated]="isBallotUnsealed" [rounds]="rounds"></app-assessors-result>
      <app-assessors-close (validateEvent)="validateTestPoll($event)" [isValidated]="isBallotUnsealed" [testStepStatus]="testStepStatus"></app-assessors-close>
    </div>

  </div>

  <!-- <assessors-change-mail-popup></assessors-change-mail-popup> -->
</div>
